export const DISCLAIMER_HEIGHT = 6.2;
